import { fetchWithErrorHandling, HttpClientError } from './fetchWithErrorHandling';

export const downloadBlobFromUrl = async (
  url: string,
  filename: string,
  errorMessages: { notFound: string; networkError: string }
): Promise<void> => {
  try {
    const resp = await fetchWithErrorHandling(url);
    const blob = await resp.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(objectUrl);
  } catch (err) {
    alert(
      err instanceof HttpClientError && err.status === 404
        ? errorMessages.notFound
        : errorMessages.networkError
    );
  }
};
